var Z = /* @__PURE__ */ ((E) => (E.DEFAULT = "default", E.SIZE_14 = "14", E.SIZE_16 = "16", E.SIZE_18 = "18", E.SIZE_20 = "20", E.SIZE_24 = "24", E.SIZE_36 = "36", E))(Z || {});
export {
  Z as MaterialIconSize
};
//# sourceMappingURL=MaterialIconSize.type.mjs.map
